import { render, staticRenderFns } from "./AdminInspirationTags.vue?vue&type=template&id=4b1d87dd&"
import script from "./AdminInspirationTags.vue?vue&type=script&lang=js&"
export * from "./AdminInspirationTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports